// toto Add,Update and View State Store

import { gql } from "@apollo/client";

export const toDoData = {
  heading: "",
  action: "",
  content: "",
  status: "",

  headingStatus: "unchecked",
  actionStatus: "unchecked",
  contentStatus: "unchecked",
  statusStatus: "unchecked",
};

// datefilter State store

export const dateFilter = {
  formDate: "",
  endDate: "",

  formDateStatus: "",
  endDateStatus: "",
};

//  toto Add,Update and View State Onchange Mange

export const toDoStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    // input type value set
    case "heading": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          heading: value,
          headingStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          heading: "",
          headingStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          heading: value,
          headingStatus: "error",
        };
      }
    }
    case "content": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          content: value,
          contentStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          content: "",
          contentStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          content: value,
          contentStatus: "error",
        };
      }
    }

    // select type value set

    case "action": {
      if (value) {
        return {
          ...state,
          action: value,
          actionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          action: "",
          actionStatus: "unchecked",
        };
      }
    }
    case "status": {
      if (value) {
        return {
          ...state,
          status: value,
          statusStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          status: "",
          statusStatus: "unchecked",
        };
      }
    }

    default:
      return state;
  }
};

// datefilter State Onchange Mange

export const dateFilterMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "formDate": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          formDate: value,
          formDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          formDate: "",
          formDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          formDate: value,
          formDateStatus: "error",
        };
      }
    }
    case "endDate": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          endDate: value,
          endDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          endDate: "",
          endDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          endDate: value,
          endDateStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};

// action options in todo form

export const actionOptions = ["Public", "Private"];

// action options in Status form

export const statusOptions = ["To Do", "In progress", "Completed", "Blocked"];

// add mutation

export const createTodoList = gql`
  mutation createtodolist($input: CreateToDoListInput!) {
    createTodoList(input: $input) {
      success

      message
    }
  }
`;

export const updateTodoList = gql`
  mutation updatetodolist($input: UpdateToDoListInput!) {
    updateTodoList(input: $input) {
      success

      message
    }
  }
`;

export const induvidualList = gql`
  query induvidualList($id: ID!) {
    induvidualList(id: $id) {
      id

      heading

      action

      content

      status

      statusDate

      createdAt

      lastUpdate
    }
  }
`;

export const deletetodolist = gql`
  mutation deletetodolist($id: ID!) {
    deleteTodoList(id: $id) {
      success

      message
    }
  }
`;
export const statusFilterList = gql`
  query statusFilterList(
    $startdate: Date
    $enddate: Date
    $status: String
    $userid: Int
    $action: String
  ) {
    statusFilterList(
      startdate: $startdate
      enddate: $enddate
      status: $status
      userId: $userid
      action: $action
    ) {
      id
      heading
      action
      content
      status
      statusDate
      createdAt
      user {
        id
        username
        employeeName
      }
    }
  }
`;

export const getIdByTodoList = gql`
  query getidbytodolist($id: ID!) {
    getIdByTodoList(id: $id) {
      id
      heading
      action
      content
      status
      statusDate
      createdAt
    }
  }
`;
